import { Outlet } from "@remix-run/react";
import { CenterContentLayout } from "@figment-fitness/ui/components/layout";

// MEMO: /auth/ は public
export default function AuthLayout() {
  return (
    <CenterContentLayout>
      <Outlet />
    </CenterContentLayout>
  );
}
